/**
 * Tema do cockpit: CLARO (padrão, Papel técnico) ou ESCURO. [Bruno 2026-10-09]
 *
 * "Habilite a possibilidade de alternar entre tema claro ou escuro." O botão
 * sol/lua no topo (LayoutSistema) chama `definirTema`; a escolha fica no
 * navegador. As cores do escuro moram em styles/tema-escuro.css, par a par com
 * o tema-papel.css.
 *
 * ⚠️ RESOLVE ANTES DO REACT MONTAR (index.js): quem lê `data-tema` durante o
 * render (a Logo) precisa do atributo já no <html> — senão aparece logo branca
 * sobre fundo branco (incidente de 23/08/2026) e um flash do tema errado.
 *
 * O antigo opt-out `?tema=azul` (skin Azul Planto) virou o tema escuro novo:
 * quem tinha guardado 'azul' passa a ver o escuro, que é o que escolheu.
 *
 * O app do cliente (/cliente) tem tema próprio no .sa-root: o atributo do
 * cockpit não é posto lá.
 */

const CHAVE = 'cockpit_tema_preview';

function _lerEscolha() {
  try {
    const url = new URLSearchParams(window.location.search).get('tema');
    if (url === 'papel' || url === 'padrao' || url === 'claro') localStorage.removeItem(CHAVE);
    else if (url === 'azul' || url === 'escuro') localStorage.setItem(CHAVE, 'escuro');
    const g = localStorage.getItem(CHAVE);
    if (g === 'azul') { localStorage.setItem(CHAVE, 'escuro'); return 'escuro'; }
    if (g === 'escuro') return 'escuro';
    if (g) localStorage.removeItem(CHAVE);
  } catch (_) { /* modo privado / storage bloqueado: fica no claro */ }
  return null;
}

function _aplicar(escolhido) {
  // Rotas do cliente e páginas públicas (link do certificado) nunca herdam o tema do cockpit.
  const naRotaDoCliente = /^\/(cliente|enviar-certificado|certificado|enviar-senha|avaliar)(\/|$)/.test(window.location.pathname || '');
  if (escolhido === 'escuro' && !naRotaDoCliente) document.documentElement.setAttribute('data-tema', 'escuro');
  else document.documentElement.removeAttribute('data-tema');
}

export function resolverTema() {
  const escolhido = _lerEscolha();
  _aplicar(escolhido);
  return escolhido;
}

/** 'claro' | 'escuro': troca na hora e guarda no navegador. */
export function definirTema(modo) {
  const escuro = modo === 'escuro';
  try {
    if (escuro) localStorage.setItem(CHAVE, 'escuro');
    else localStorage.removeItem(CHAVE);
  } catch (_) { /* sem storage: vale só nesta aba */ }
  _aplicar(escuro ? 'escuro' : null);
  // Tira o ?tema= da barra: senão o próximo recarregamento desfaz a escolha.
  try {
    const url = new URL(window.location.href);
    if (url.searchParams.has('tema')) {
      url.searchParams.delete('tema');
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    }
  } catch (_) { /* URL exótica */ }
  try { window.dispatchEvent(new CustomEvent('cockpit-tema', { detail: { tema: escuro ? 'escuro' : 'claro' } })); } catch (_) { /* ok */ }
}

/** Mantido pelo nome antigo: volta pro claro. */
export function desligarTema() { definirTema('claro'); }

/** 'escuro' ou null (claro). */
export function temaAtivo() {
  try { return document.documentElement.getAttribute('data-tema'); } catch (_) { return null; }
}
